import { css } from '@emotion/react';
import { css as globalCss, theme } from 'global';

export const headerDropdowns = css`
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: ${theme.breaks.sm}px) {
    display: none;
  }
`;

export const noWrap = css`
  flex-wrap: nowrap;
`;

export const iconStyling = css`
  ${globalCss.icon(true, '38px', '38px')};
  ${globalCss.backgroundIcon(true)};

  @media screen and (max-width: ${theme.breaks.md}px) {
    order: 2;
    margin-left: 16px;
  }

  @media screen and (max-width: ${theme.breaks.xs}px) {
    ${globalCss.icon(true, '24px', '24px')};
    ${globalCss.backgroundIcon(false)};
  }
`;

export const merchantDropdown = css`
  margin: 0 8px 0 0 !important;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    margin-right: 0 !important;
  }

  @media screen and (max-width: ${theme.breaks.md}px) {
    margin-bottom: 16px !important;
  }
`;

export const outlineSelectStyle = css`
  margin: 0;
  max-width: fit-content;

  @media screen and (max-width: ${theme.breaks.md}px) {
    margin-top: 16px;
    max-width: 100%;
  }
`;
